import { call, put, select, takeLatest } from 'redux-saga/effects';
import {
  WS_NEW_NOTIFY,
  WS_CLEAR_ACTOR_NOTIFY,
  WS_CLEAR_NOTIFY,
  WS_CREATE_ACCESS,
} from 'constants';
import { WS_CREATE_ACTOR } from '@control-front-end/common/constants/graphActors';
import { WS_CREATE_REACTION } from '@control-front-end/common/constants/reactions';
import AppUtils from '@control-front-end/utils/utils';
import TabNotify from '@control-front-end/utils/tabNotify';
import history from '../store/history';

// Отправить счетчик уведомлений в electron
function* sendElectronBadgeCounter() {
  if (!window.electron) return;
  const wsNotifyItems = yield select((state) => state.wsNotify);
  window.electron.send('badgeCounter', wsNotifyItems.length);
}

// Отправить нотификацию в электрон
function sendElectronNotify(model) {
  if (!window.electron) return;
  window.electron.send('notify', model);
}

// Проверить надо ли обрабатывать пакет из WS
function* isHandleWSPacket(payload, userId) {
  const accounts = yield select((state) => state.accounts);
  const auth = yield select((state) => state.auth);
  const { accId } = payload.model;
  return accounts.active === accId && auth.id !== userId;
}

/**
 * Создать уведомление о акторе
 */
function* createActorNotification({ payload, extraData }) {
  const { model, objType, userId } = payload;
  if (objType !== 'actor') return;
  const isHandle = yield call(isHandleWSPacket, payload, userId);
  if (!isHandle) return;
  const config = yield select((state) => state.config);
  const notifyList = yield select((state) => state.wsNotify);
  const systemForms = yield select((state) => state.systemForms);
  const isEvent = systemForms.events.id === model.formId;
  const url = `/actors_graph/${AppUtils.makeShortAccountId(model.accId)}/view/${
    model.id
  }`;
  const copyNotifyList = notifyList.slice();

  const notifyModel = {
    id: AppUtils.udid(),
    ownerId: model.userId,
    ownerAvatar: config.avatarPath.replace('{userId}', model.userId),
    ownerName: model.user.nick,
    description: AppUtils.removeHtmlTags(
      AppUtils.smileToHtml(model.description || '')
    ),
    attachments: model.attachments,
    title: model.title,
    createdAt: model.createdAt,
    actorId: model.id,
    accId: model.accId,
    type: isEvent ? 'newEvent' : 'newActor',
    popupTitle: `${model.user.nick} create ${isEvent ? 'event' : 'actor'}:`,
    url,
    ...extraData,
  };
  copyNotifyList.unshift(notifyModel);
  yield put({ type: WS_NEW_NOTIFY, payload: copyNotifyList });
  // Уведомление в title таба
  TabNotify.updateTitle();
  // Уведомление popup
  TabNotify.setPopup({
    icon: notifyModel.ownerAvatar,
    title: notifyModel.popupTitle,
    body: notifyModel.title,
    url,
    callback: (path) => history.push(path),
  });
  yield call(sendElectronBadgeCounter);
  sendElectronNotify(notifyModel);
}

/**
 * Создать уведомление о реакции
 */
function* createReactionNotification({ payload }) {
  const { model } = payload;
  const { id, accId, data, treeInfo, user } = model;
  const actorView = yield select((state) => state.actorView);
  if (data.type === 'view' || actorView.id === treeInfo.rootActorId) return;
  const url = `/actors_graph/${AppUtils.makeShortAccountId(accId)}/view/${
    treeInfo.rootActorId
  }?rid=${id}`;
  const extraData = {
    title: treeInfo.rootActorTitle,
    actorId: treeInfo.rootActorId,
    type: data.type,
    popupTitle: `${user.nick} commented:`,
    url,
  };
  yield createActorNotification({ payload, extraData });
}

/**
 * Очистить нотификации события
 */
function* clearNotification({ payload: actorId }) {
  const notifyList = yield select((state) => state.wsNotify);
  const filterNotify = notifyList.filter((i) => i.actorId !== actorId);
  yield put({ type: WS_NEW_NOTIFY, payload: filterNotify });
  yield call(sendElectronBadgeCounter);
}

/**
 * Очистить все нотификации
 */
function* clearAllNotification() {
  yield call(sendElectronBadgeCounter);
}

function* wsNotify() {
  yield takeLatest(WS_CREATE_ACTOR, createActorNotification);
  yield takeLatest(WS_CREATE_ACCESS, createActorNotification);
  yield takeLatest(WS_CREATE_REACTION, createReactionNotification);
  yield takeLatest(WS_CLEAR_ACTOR_NOTIFY, clearNotification);
  yield takeLatest(WS_CLEAR_NOTIFY, clearAllNotification);
}

export default wsNotify;
